<template>
    <div class="contenedor_modal_sin_fondo">
        <div class="contenedor_modal_cuerpo">
            <div class="contenedor_modal_cabecera">
                <b-button type="button" size="sm" variant="danger" @click="cerrar"><i
                        class="fas fa-times"></i></b-button>
            </div>

            <b-container fluid="">
                <b-row>
                    <div class="col-sm-12 mt-3">
                        <h3>
                            {{ objeto_busqueda.nombre }}
                        </h3>
                    </div>
                    <div class="col-sm-4 mt-3">
                        <label for="" class="form-label">Precio Costo</label>
                        <input type="number" step="0.01" min="0" v-model="precio_costo"
                            class="form-control form-control-sm">
                    </div>
                    <div class="col-sm-4 mt-3">
                        <label for="" class="form-label">Precio Venta</label>
                        <input type="number" step="0.01" min="0" v-model="precio_venta"
                            class="form-control form-control-sm">
                    </div>
                    <div class="col-sm-4 mt-3">
                        <label for="" class="form-label">Precio Efectivo</label>
                        <input type="number" step="0.01" min="0" v-model="precio_efectivo"
                            class="form-control form-control-sm">
                    </div>
                    <div class="col-sm-12 mt-3 mb-3">
                        <button v-if="permisos['inventarios.busqueda.actualizar_precios']?.actualizar || ES_ROOT"
                            type="button" class="btn btn-sm btn-outline-dark btn-block"
                            @click="ejecutar_actualizacion">Actualizar</button>
                        <button v-else type="button" disabled class="btn btn-sm btn-outline-dark btn-block"
                            @click="ejecutar_actualizacion">Actualizar</button>
                    </div>
                </b-row>
            </b-container>
        </div>
    </div>
</template>

<script>
    import { minix } from '@/components/functions/alertas';
    import { mapActions, mapGetters, mapMutations, mapState } from 'vuex';

    export default {
        name: 'ModalActualizarPrecios',
        computed: {
            ...mapState(['objeto_busqueda', 'permisos']),
            ...mapGetters(['ES_ROOT'])
        },
        data() {
            return {
                precio_costo: 0,
                precio_venta: 0,
                precio_efectivo: 0
            }
        },
        methods: {
            cerrar() {
                this.$emit('salir')
            },
            async ejecutar_actualizacion() {

                if (this.precio_costo <= 0 || this.precio_venta <= 0 || this.precio_efectivo <= 0) {
                    minix({ icon: 'error', mensaje: 'Todos los campos son obligatorios', tiempo: 3000 })

                } else {
                    let f = {
                        api: `articulos/${this.objeto_busqueda.documentId ?? this.objeto_busqueda.document_id}`,
                        formulario: {
                            precio_costo: this.precio_costo,
                            precio_venta: this.precio_venta,
                            precio_efectivo: this.precio_efectivo
                        }
                    }

                    await this.actualizar_data(f)
                    this.set_datos_modificacion_busqueda({
                        precio_costo: this.precio_costo,
                        precio_venta: this.precio_venta,
                        precio_efectivo: this.precio_efectivo
                    })
                    this.cerrar()
                }
            },
            ...mapActions(['actualizar_data']),
            ...mapMutations(['set_modal_cambio_precios', 'set_datos_modificacion_busqueda'])
        },
        mounted() {
            this.set_modal_cambio_precios(false)
            this.precio_costo = this.objeto_busqueda.precio_costo
            this.precio_venta = this.objeto_busqueda.precio_venta
            this.precio_efectivo = this.objeto_busqueda.precio_efectivo
        },
    }
</script>

<style>
    .contenedor_modal_sin_fondo {
        width: 100%;
        height: 100vh;
        position: fixed;
        top: 0;
        left: 0;
        z-index: 999;
        background-color: rgba(0, 0, 0, 0.1);
        display: flex;
        justify-content: center;
        align-items: center;
    }
</style>